<template>

  <div class="confirmation ma-4">
        <div class="text-xs-left title ma-2">
          Order Confirmation
        </div>
        <hr />
        <v-layout>
          <v-flex >

            <span class="headline">Thank you for your order!</span> <br /><br />
            <span class="subheading">Your order number is: <b>{{ orderNumber }}</b>  <br />
            An email confirmation was sent to <b>{{ email }}</b>
            </span>
          </v-flex>
        </v-layout>
  </div>

</template>

<script>
import {mapState} from 'vuex'
// const firebase = require('firebase/app')

export default {
  name: 'OrderConfirmation',
  components: {
  },
  data: function () {
    return {
    }
  },
  mounted: function () {

    // We have an order, log to Google Analytics
    this.$ga.event({
      eventCategory: 'order',
      eventAction: 'orderAction',
      eventLabel: 'order',
      eventValue: 123
    })
  },
  methods: {

  },
  computed: {
    ...mapState({
      cartItems: state => state.cart.items,
      email: state => state.buyerInfo.email,
      // orderNumber: state => state.shopping.orderNumber.orderNumber || "No Order"
    }),
    orderNumber: function () {
      // return "No order"
      if (this.$store.state.shopping.orderNumber != null) {
        return this.$store.state.shopping.orderNumber.orderNumber
        // return this.$store.state.shopping.orderNumber.orderNumber
      } else {
        return "No order"
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.confirmation {

}

</style>
